<template>
    <v-app  id="app" :style="{'font-size':''+valorFont+'px'}">
      <v-main fluid>
        <navUser id="navusercont"/>
        <transition>
          <router-view class="cont-general">
          </router-view>
        </transition>
     </v-main>   
    </v-app>
</template>

<script>
import navUser from './components/nav-user';

export default {
  name: 'App',
  components: {
    navUser
  },
  data() {
    return {
      valorFont: 13,
      topNav: null
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted() {
    // console.log(this.$route.path)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
  },
};
</script>
<style lang="scss">
@import 'src/scss/globals';
#app{
  width: 100%;
  font-family: "CenturyGothic";
  margin: 0px;
  padding: 0px;
  background-size: cover;
  background-attachment: fixed;
}

.fill-viewport-height {
  height: 100vh; //Antes estaba 100% pero no funcionaba en navegadores iOS
}

button:focus{
  outline: none!important;
}

/********************  FONTS ********************/
/* Las fuentes se cargan acá porque se tiene acceso a los recursos que están en assets*/

@font-face {
  font-family: CenturyGothic;
  src: url("../src/assets/fonts/CenturyGothic.ttf");
  font-weight: normal;
}
.cont-general{
  padding-top: 50px;
}
.cont-footer{
  margin-top: 0px;
}
.backver{
  background: url("./assets/img/check.svg");

}
.bot-check-vis, .bot-check-vis-cen, .feedback-mal, .feedback-mal-cen {
  position: relative;
}

.bot-check-vis:after, .feedback-mal:after {
  content: " ";
  background: url("./assets/img/check.svg");
  background-size: contain;
  position: absolute;
  width: 25px;
  height: 25px;
  top: -8px;
  right: -8px
}
// .feedback-mal:after {
//   background-image: url("./assets/imagenes_compartidas/Cerrar_Ventana.png");
// }

.bot-check-vis-cen:after, .feedback-mal-cen:after {
  content: " ";
  background: url("./assets/img/check.svg");
  background-size: contain;
  position: absolute;
  width: 30px;
  height: 30px;
  top: -20px;
  right: 0;
  left: 0;
  margin: auto;
}
</style>
